import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { formatMoney } from "@faire/web--source/common/money";
import { Exclusivity as ExclusivityIcon } from "@faire/web--source/slate/icons/foundation/Exclusivity";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import differenceInDays from "date-fns/differenceInDays";
import React from "react";
import { ExclusivityLink } from "@faire/retailer/features/Exclusivity/DetailsModal/ExclusivityLink";
import { getStateInfoFromAvailability } from "@faire/retailer/features/Exclusivity/getStateInfoFromAvailability";
import { useExclusivityAvailability } from "@faire/retailer/hooks/exclusivity/useExclusivityAvailability";
export var ExclusivityLabel = function(param) {
    var brandToken = param.brandToken;
    var availability = useExclusivityAvailability(brandToken).availability;
    var isActivated = getStateInfoFromAvailability(availability).isActivated;
    var _ref = availability !== null && availability !== void 0 ? availability : {}, commitment_balance_left_to_spend = _ref.commitment_balance_left_to_spend, expires_at = _ref.expires_at, exclusivity_agreement_token = _ref.exclusivity_agreement_token;
    var balanceLeftString = commitment_balance_left_to_spend ? formatMoney({
        money: commitment_balance_left_to_spend,
        omitCentsIfZero: true
    }) : "";
    var daysToExpire = differenceInDays(expires_at !== null && expires_at !== void 0 ? expires_at : 0, Date.now());
    var showBalanceLeft = (commitment_balance_left_to_spend === null || commitment_balance_left_to_spend === void 0 ? void 0 : commitment_balance_left_to_spend.amount_cents) && commitment_balance_left_to_spend.amount_cents > 0;
    var showExpiration = !showBalanceLeft && daysToExpire <= 90;
    if (!isActivated) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsxs(Row, {
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(ExclusivityIcon, {
                        color: Decorative.shade.orange,
                        fontSize: "16px",
                        margin: "2px 0 0 0"
                    }),
                    /*#__PURE__*/ _jsx(ExclusivityLink, {
                        origin: "product",
                        agreementToken: exclusivity_agreement_token,
                        brandToken: brandToken
                    }),
                    showBalanceLeft ? /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "cOKHyW",
                            defaultMessage: [
                                {
                                    type: 1,
                                    value: "balanceLeftMoney"
                                },
                                {
                                    type: 0,
                                    value: " left to spend"
                                }
                            ],
                            values: {
                                balanceLeftMoney: balanceLeftString
                            }
                        })
                    }) : null,
                    showExpiration ? /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "RQnfVL",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "ends in "
                                },
                                {
                                    type: 1,
                                    value: "daysToExpireNumber"
                                },
                                {
                                    type: 0,
                                    value: " days"
                                }
                            ],
                            values: {
                                daysToExpireNumber: daysToExpire
                            }
                        })
                    }) : null
                ]
            })
        ]
    });
};
